import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SCROLLABLE_CONTAINER } from '../../common/constants';
import { media } from '../../common/styles';

const S = {
  Wrapper: styled.div`
    display: flex;
    overflow-x: scroll;
    overflow-y: hidden;
    min-height: 100vh;
  `,
  Floated: styled.div`
    position: absolute;
    left: 0;
    z-index: 1000;
  `,
  Fixed: styled.div`
    position: fixed;
  `,
  Padder: styled.div`
    flex-grow: 1;
    margin-top: 5rem;
  `,
  Main: styled.main`
    /* XXX: 고정 레이아웃 적용 */
    padding: 0 60px;
  `,
  CenteredBlock: styled.div`
    /* XXX: 고정 레이아웃 적용
       min-width: 1208px;
       padding: 0 5%;
    */
    width: 1088px;
    margin: 0 auto;
    ${media.lg`
      width: 984px;
    `}
    ${media.xl`
      width: 1224px;
    `}
  `,
};

const Layout = ({ children }) => (
  <S.Wrapper id={SCROLLABLE_CONTAINER}>
    <S.Padder>
      <S.Main id="main">
        <S.CenteredBlock>
          {children}
        </S.CenteredBlock>
      </S.Main>
    </S.Padder>
  </S.Wrapper>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
